import { setNextAvailable } from 'actions/timer';
import { IActionsService } from 'types/actions';
import computeNextActionsAt from 'utils/computeNextActionsAt';
import ActionsService from 'services/ActionsService';

import {
  FETCH_ACTIONS_ERROR,
  FETCH_ACTIONS_REQUESTED,
  FETCH_ACTIONS_SUCCESS,
} from 'actiontypes/actions';
import { logoutUser } from 'actions/user';

export const fetchActionsError = (error: any) => ({ error, type: FETCH_ACTIONS_ERROR });

export const fetchActionsRequested = () => ({ type: FETCH_ACTIONS_REQUESTED });

export const fetchActionsSuccess = (data: any) => ({
  type: FETCH_ACTIONS_SUCCESS,
  payload: data,
});

export default fetchActions(new ActionsService());

export function fetchActions(service: IActionsService) {
  return () => async (dispatch: Function) => {
    dispatch(fetchActionsRequested());
    try {
      const { data } = await service.fetchActions();
      dispatch(fetchActionsSuccess(data)); // update actions state slice
      const nextActionsAt = computeNextActionsAt(data);
      dispatch(setNextAvailable(nextActionsAt)); // update timer's awareness
      return data;
    } catch (error) {
      if (error && error.response && error.response.status && error.response.status === 401) {
        return dispatch(logoutUser());
      }
      dispatch(fetchActionsError(error));
      throw error;
    }
  };
}
